import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { lighten, styled } from '@mui/material/styles';

const BorderLinearProgress = styled(LinearProgress)({
    height: 20,
    backgroundColor: lighten('#ff6c5c', 0.8),
    '& .MuiLinearProgress-bar': {
        backgroundColor: '#ff6c5c',
    },
});

const ProductUpdateProgress = (props) => {
    const getPercentActualFromPotential = (updated, total) => {
        if (updated === 0) return 0;
        return (updated / total) * 100;
    };

    return (
        <span>
            <BorderLinearProgress
                variant="determinate"
                value={getPercentActualFromPotential(props.updated, props.total)}
            />
        </span>
    );
};

export default ProductUpdateProgress;
